import { render } from "./MSubmissionsSection.vue?vue&type=template&id=42b41a8c"
import script from "./MSubmissionsSection.vue?vue&type=script&lang=ts"
export * from "./MSubmissionsSection.vue?vue&type=script&lang=ts"
script.render = render

export default script